import React from 'react';

import Button from '../../../../../Table/Row/Button';

export default function Buttons({
  row,
  deleteBillLineItemId,
  editingBillLineItemId,
  isFetching,
  isBillLineItemUpdating,
  isBillPayed,
  editingBillLineItemAmount,
  editingBillLineItemDescription,
  updateBillLineItem,
  deleteBillLineItem,
  setEditingBillLineItemId,
}) {
  const isVisible =
    row.id !== deleteBillLineItemId &&
    (row.id !== editingBillLineItemId ||
      (!isBillLineItemUpdating && !isFetching)) &&
    !(row.id !== editingBillLineItemId && isBillPayed) &&
    !isBillPayed &&
    row.id !== 'total';

  return (
    <div className="flex gap-5">
      <Button
        disabled={
          editingBillLineItemId &&
          (!editingBillLineItemAmount || !editingBillLineItemDescription)
        }
        onClick={() =>
          row.id === editingBillLineItemId
            ? updateBillLineItem()
            : deleteBillLineItem(row.id)
        }
        label={row.id === editingBillLineItemId ? 'Save' : 'Delete'}
        isVisible={isVisible}
      />

      {row.id === editingBillLineItemId && isVisible && (
        <button
          type="button"
          className="underline bg-transparent border-none text-blue-500 hover:text-blue-700 focus:outline-none dark:text-blue-300 dark:hover:text-blue-500"
          onClick={() => setEditingBillLineItemId(null)}
        >
          Cancel
        </button>
      )}
    </div>
  );
}
